import { render, staticRenderFns } from "./PaymentRequestView.vue?vue&type=template&id=2e4436e6&scoped=true&"
import script from "./PaymentRequestView.vue?vue&type=script&lang=js&"
export * from "./PaymentRequestView.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRequestView.vue?vue&type=style&index=0&id=2e4436e6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4436e6",
  null
  
)

export default component.exports